module.exports = [
	{
		"name": "Academy Sports & Outdoors",
		"url": "https://www.academy.com/shop/browse/search?searchTerm=sentrysafe",
		"image": "academy.jpg",
		"region": "United States"
	},
	{
		"name": "Amazon",
		"url": "https://www.amazon.com/sentrysafe?&_encoding=UTF8&tag=sentrysafe06-20&linkCode=ur2&linkId=ce82e302771d95040dd9dd5e2748304e&camp=1789&creative=9325",
		"image": "amazon.jpg",
		"region": "United States"
	},
	{
		"name": "BJ's Wholesale Club",
		"url": "https://www.bjs.com/search/sentrysafe/q?template=clp",
		"image": "bjs.jpg",
		"region": "United States"
	},
	{
		"name": "Cabela's",
		"url": "https://www.cabelas.com/shop/en/SearchDisplay?categoryId=&storeId=10651&catalogId=10551&langId=-1&sType=SimpleSearch&resultCatEntryType=2&showResultsPage=true&searchSource=Q&pageView=&beginIndex=0&pageSize=16&searchTerm=sentrysafe#facet:&productBeginIndex:0&facetLimit:&orderBy:&pageView:grid&minPrice:&maxPrice:&pageSize:&",
		"image": "cabelas.jpg",
		"region": "United States"
	},
	{
		"name": "Costco",
		"url": "https://www.costco.com/CatalogSearch?dept=All&keyword=sentrysafe",
		"image": "costco.jpg",
		"region": "United States"
	},
	{
		"name": "Lowes",
		"url": "https://www.lowes.com/search?searchTerm=sentrysafe",
		"image": "lowes.jpg",
		"region": "United States"
	},
	{
		"name": "Office Depot/OfficeMax",
		"url": "https://www.officedepot.com/a/browse/safes/N=5+733967/",
		"image": "officedepot-officemax.jpg",
		"region": "United States"
	},
	{
		"name": "Sam's Club",
		"url": "https://www.samsclub.com/s/sentrysafe",
		"image": "sams-club.jpg",
		"region": "United States"
	},
	{
		"name": "Staples",
		"url": "https://www.staples.com/sentrysafe/directory_sentrysafe",
		"image": "staples.jpg",
		"region": "United States"
	},
	{
		"name": "Home Depot",
		"url": "https://www.homedepot.com/s/sentrysafe?NCNI-5",
		"image": "home-depot.jpg",
		"region": "United States"
	},
	{
		"name": "Walmart",
		"url": "https://www.walmart.com/search?q=sentrysafe",
		"image": "walmart.jpg",
		"region": "United States"
	},
	{
		"name": "Acklands Grainger",
		"url": "https://www.grainger.ca/en/category/Security/Safes/c/2174?filterType=brand&filterName=Brand&filterValue=SENTRY+SAFE&isWildCard=false&isIgnMinMatchFilter=true&q=sentrysafe%3AtopSeller%3Abrand%3ASENTRY%2BSAFE&text=sentrysafe&remove_token=sentrysafe&type=ts&cptype=ts#",
		"image": "acklands-grainger.jpg",
		"region": "Canada"
	},
	{
		"name": "Amazon CA",
		"url": "https://www.amazon.ca/s?k=sentrysafe&ref=nb_sb_noss_2",
		"image": "amazonCA.jpg",
		"region": "Canada"
	},
	{
		"name": "Basics",
		"url": "https://www.basics.com",
		"image": "basics.jpg",
		"region": "Canada"
	},
	{
		"name": "Costco",
		"url": "https://www.costco.ca/CatalogSearch?dept=All&keyword=sentrysafe",
		"image": "costco.jpg",
		"region": "Canada"
	},
	{
		"name": "Home Hardware",
		"url": "https://www.homehardware.ca/en/search?query=sentrysafe",
		"image": "home-hardware.jpg",
		"region": "Canada"
	},
	{
		"name": "OfficeMax Grand & Toy",
		"url": "https://www.grandandtoy.com/EN/search/pages/browse?Ntt=sentrysafe&Ntk=All&soffer=false",
		"image": "officemax-grand-and-toy.jpg",
		"region": "Canada"
	},
	{
		"name": "Staples",
		"url": "https://www.staples.ca/search?query=sentrysafe",
		"image": "staples.jpg",
		"region": "Canada"
	},
	{
		"name": "Home Depot",
		"url": "https://www.homedepot.ca/search?q=sentrysafe#!q=sentrysafe",
		"image": "home-depot.jpg",
		"region": "Canada"
	},
	{
		"name": "Walmart",
		"url": "https://www.walmart.ca/search?q=sentrysafe",
		"image": "walmart.jpg",
		"region": "Canada"
	},
	{
		"name": "Ace Hardware",
		"url": "https://www.aceuae.com/en-AE/our-brands/sentry/",
		"image": "ace-hardware.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Amazon UK",
		"url": "https://www.amazon.co.uk/s?k=SentrySafe&ref=nb_sb_noss_2",
		"image": "amazon-uk.png",
		"region": "United Kingdom"
	},
	{
		"name": "Costco",
		"url": "https://www.costco.co.uk/search?text=sentrysafe",
		"image": "costco-uk.png",
		"region": "United Kingdom"
	},
	{
		"name": "De Raat",
		"url": "http://www.deraat.eu",
		"image": "de-raat.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Ferrimax",
		"url": "https://www.ferrimax.com",
		"image": "ferrimax.png",
		"region": "United Kingdom"
	},
	{
		"name": "NCR Angola",
		"url": "https://www.ncrangola.com/loja/particulares/pt/pesquisa?controller=search&orderby=position&orderway=desc&search_query=sentrysafe&submit_search=",
		"image": "ncr-angola.jpg",
		"region": "United Kingdom"
	},
	{
		"name": "Tmall",
		"url": "https://sentrysafe.tmall.com/",
		"image": "tmall.jpg",
		"region": "United Kingdom"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/whereToBuy/retailerData.json
// module id = 776
// module chunks = 0